import { ROUTE_IMPORTERS } from "../routePrefetchMap";

// Warm a route's lazy chunk (idempotent). Called on nav-link hover/focus so
// the code for the next screen is already parsed by the time the user clicks —
// navigation then feels instant instead of flashing the Suspense fallback.
const warmed = new Set();

export function prefetchRoute(to) {
  if (!to || typeof to !== "string") return;
  const path = to.split("?")[0];
  const importer = ROUTE_IMPORTERS[path];
  if (!importer || warmed.has(path)) return;
  warmed.add(path);
  // Defer a tick so hovering while scrolling doesn't compete with rendering.
  Promise.resolve().then(importer).catch(() => warmed.delete(path));
}
